import { ActionComplaintsComponent } from "./action/action-complaints.component";
import { CreateComplaintsComponent } from "./create/create-complaints.component";
import { EditComplaintComponent } from "./edit-complaint.component";
import { ViewComplaintsComponent } from "./view/view-complaints.component";

export const ComplaintsDeclaration = [
    CreateComplaintsComponent,
    EditComplaintComponent,
    ViewComplaintsComponent,
    ActionComplaintsComponent,
    
]